import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import "swiper/css";
import {
    Mousewheel,
    Keyboard,
    FreeMode,
    Scrollbar,
    Navigation,
} from "swiper/modules";
import { useMatchMedia } from "stimulus-use";

export default class extends Controller {
    static targets = ["swiper", "wrapper", "slide", "scrollbar", "navigation"];
    static values = {
        params: Object,
    };

    initialize() {}

    connect() {
        this.options = {
            modules: [FreeMode, Mousewheel, Keyboard],
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 8,
            grabCursor: true,
            keyboard: {
                enabled: true,
            },
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis: true,
            },
            freeMode: {
                enabled: true,
            },
        };

        useMatchMedia(this, {
            mediaQueries: {
                mobile: "(max-width: 768px)",
                tablet: "(max-width: 1024px)",
            },
        });
        const mobileMediaQuery = window.matchMedia("(max-width: 768px)");
        const tabletMediaQuery = window.matchMedia("(max-width: 1024px)");

        // Init All Instances that have no mediaQueries
        if (!this.paramsValue.untilMobile && !this.paramsValue.untilTablet) {
            this.initSlider();
        }
        // Check for Mobile Media Queries
        if (mobileMediaQuery.matches && this.paramsValue.untilMobile) {
            this.initSlider();
        }
        // Check for Tablet Media Queries
        if (tabletMediaQuery.matches && this.paramsValue.untilTablet) {
            this.initSlider();
        }
    }

    update(e) {
        this.swiper.update();
    }

    isTablet({ name, media, matches, event }) {
        if (matches && this.paramsValue.untilTablet) {
            this.initSlider();
        }
    }
    notTablet({ name, media, matches, event }) {
        if (!matches && this.paramsValue.untilTablet) {
            this.destroySlider();
        }
    }

    isMobile({ name, media, matches, event }) {
        if (matches && this.paramsValue.untilMobile) {
            this.initSlider();
        }
    }

    notMobile({ name, media, matches, event }) {
        if (!matches && this.paramsValue.untilMobile) {
            this.destroySlider();
        }
    }

    initSlider() {
        this.swiperTarget.classList.add("swiper");
        this.wrapperTarget.classList.add("swiper-wrapper");
        this.slideTargets.forEach((item) => {
            item.classList.add("swiper-slide");
        });
        this.swiper = new Swiper(this.swiperTarget, this.options);
    }

    destroySlider() {
        this.swiper?.destroy();
        this.swiperTarget.classList.remove("swiper");
        this.wrapperTarget.classList.remove("swiper-wrapper");
        this.slideTargets.forEach((item) => {
            item.classList.remove("swiper-slide");
        });
    }
}
